import {Link} from "@tanstack/react-router";

function NotFoundPage(){

    return (
        <div className="flex flex-col min-h-screen bg-chromatic w-full">
            <div className="w-full h-screen flex flex-col items-center justify-center">
                <h1 className="font-noto-sans-mono text-9xl text-white font-semibold font-stretch-extra-expanded">404</h1>
                <p className="font-noto-sans-mono text-4xl text-white/50">Сторінку не знайдено</p>
                <Link to="/" className="mt-8 text-white text-xl bg-[#63655B] py-2 px-4 rounded-lg hover:underline">На головну</Link>
            </div>

        </div>
    )
}

export default NotFoundPage;